module.exports = __webpack_public_path__ + "static/media/20190916444.f6724e24.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/20190916444.png
// module id = 38
// module chunks = 0